<template>
  <div class="main">
    <c-panel title="Autores" titleIcon="fas fa-feather-alt">
      <!-- Item 10 do edital: "cadastro de Autores, permitindo manter os dados cadastrais". -->
      <catalogo-crud tipo="autor" rotuloNovo="NOVO AUTOR" nomeSingular="autor"
                     placeholderBusca="Pesquisar por nome, forma de apresentação ou nacionalidade"
                     :campos="campos" :colunas="colunas"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'nome', label: 'Nome', obrigatorio: true, span: 12, max: 191 },
      // Forma catalográfica é DADO, não derivação do nome — por isso se digita, não se calcula.
      { chave: 'nome_apresentacao', label: 'Forma de apresentação (ex.: ASSIS, Machado de)', span: 12, max: 191 },
      { chave: 'nacionalidade', label: 'Nacionalidade', span: 8, max: 60 },
      { chave: 'ano_nascimento', label: 'Ano de nascimento', tipo: 'numero', span: 8 },
      { chave: 'ano_falecimento', label: 'Ano de falecimento', tipo: 'numero', span: 8 },
      { chave: 'biografia', label: 'Biografia', tipo: 'textarea', span: 24, linhas: 4 }
    ],
    colunas: [
      { chave: 'nome', label: 'Nome' },
      { chave: 'nome_apresentacao', label: 'Apresentação', mobileOculto: true },
      { chave: 'nacionalidade', label: 'Nacionalidade', largura: '140px', mobileOculto: true }
    ]
  })
}
</script>
